/*
  OFFE - product page (Oct 27, 2026): "These are cute too..." and "Recently
  viewed" show about 3.9 cards on desktop (Figma: 297px cards, 360px apart
  on a 1440 screen) instead of the 6 the section settings ask for. Waits for
  the theme to build each slider, then changes it. Loaded with
  assets/custom-product-figma.css from layout/theme.liquid.
*/
(function () {
  var SEL = '.product-recommendations-section .swiper, .recently-viewed-section .swiper';
  function patch(el) {
    var sw = el.swiper;
    if (!sw) return false;
    if (sw.__offePP) return true;
    sw.__offePP = true;
    var bp = sw.params.breakpoints || (sw.params.breakpoints = {});
    Object.keys(bp).forEach(function (k) {
      if (+k >= 1160) bp[k] = Object.assign({}, bp[k], { slidesPerView: 3.9, slidesPerGroup: 1, spaceBetween: 0 });
    });
    bp[1160] = Object.assign({}, bp[1160], { slidesPerView: 3.9, slidesPerGroup: 1, spaceBetween: 0 });
    sw.currentBreakpoint = null;
    sw.setBreakpoint();
    sw.update();
    return true;
  }
  function scan() {
    document.querySelectorAll(SEL).forEach(patch);
  }
  function run() {
    if (!document.body.classList.contains('template-product')) return;
    var tries = 0;
    (function tick() {
      scan();
      if (++tries < 100) setTimeout(tick, 150);
    })();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/*
  Same rows: a size in a card's hover strip opens Quick View with that size
  picked (Rachel, Oct 27; as on the homepage and collection pages). Colour
  dots with no named
  colour (data-sample) take the main colour of their photo.
*/
(function () {
  var ROWS = '.template-product :is(.product-recommendations-section, .recently-viewed-section)';
  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(min-width: 1160px)').matches) return;
    var label = event.target.closest && event.target.closest(ROWS + ' .product-card__information-bottom .product-card__option-group[data-option-position] label');
    if (!label) return;
    event.preventDefault();
    event.stopPropagation();
    // opens Quick View with that size picked (custom-figma-desktop.js)
    if (window.offeSizeToQuickView) { window.offeSizeToQuickView(label); return; }
    var card = label.closest('.product-card');
    var quickView = card && card.querySelector('.product-card__quickview .product-card__button');
    if (quickView) quickView.click();
  }, true);

  function sample(dot) {
    var src = dot.getAttribute('data-sample');
    if (!src) return;
    dot.removeAttribute('data-sample');
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var size = 32;
        var canvas = document.createElement('canvas');
        canvas.width = size; canvas.height = size;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, size, size);
        var data = ctx.getImageData(0, 0, size, size).data;
        var px = function (x, y) { var i = (y * size + x) * 4; return [data[i], data[i + 1], data[i + 2]]; };
        var c = [px(0, 0), px(size - 1, 0), px(0, size - 1), px(size - 1, size - 1)];
        var bg = [0, 1, 2].map(function (k) { return (c[0][k] + c[1][k] + c[2][k] + c[3][k]) / 4; });
        var r = 0, g = 0, b = 0, n = 0;
        for (var y = 4; y < size - 4; y++) {
          for (var x = 4; x < size - 4; x++) {
            var p = px(x, y);
            if (Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) < 60) continue;
            if (p[0] > 235 && p[1] > 235 && p[2] > 235) continue;
            r += p[0]; g += p[1]; b += p[2]; n++;
          }
        }
        if (n < 12) return;
        dot.style.setProperty('--swatch', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
      } catch (e) { /* photo not readable: keep the grey */ }
    };
    img.src = src;
  }
  function run() {
    document.querySelectorAll(ROWS + ' .offe-swatch[data-sample]').forEach(sample);
  }
  function start() {
    if (!document.body.classList.contains('template-product')) return;
    run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Product photos on phones (up to 1159px): one photo at a time (the CSS
  makes each slide full width) with a row of dots under them, the active
  one plum. Tapping a dot goes to that photo.
*/
(function () {
  function build() {
    var el = document.querySelector('.template-product .product-section .product__media-list.swiper');
    var sw = el && el.swiper;
    if (!sw) return false;
    if (el.__offeDots) return true;
    el.__offeDots = true;
    var wrap = el.closest('.product__media-list-wrapper') || el;
    var dots = document.createElement('div');
    dots.className = 'offe-pp-dots';
    dots.setAttribute('aria-hidden', 'true');
    function render() {
      var n = sw.slides.length;
      if (dots.children.length !== n) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('span');
          b.className = 'swiper-pagination-bullet';
          (function (k) { b.addEventListener('click', function () { sw.slideTo(k); }); })(i);
          dots.appendChild(b);
        }
      }
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.classList.toggle('swiper-pagination-bullet-active', i === sw.activeIndex);
      });
      dots.style.display = n > 1 ? '' : 'none';
    }
    wrap.parentNode.insertBefore(dots, wrap.nextSibling);
    sw.on('slideChange', render);
    sw.on('slidesLengthChange', render);
    sw.update();
    render();
    return true;
  }
  function run() {
    if (!document.body.classList.contains('template-product')) return;
    var tries = 0;
    (function tick() { if (!build() && ++tries < 60) setTimeout(tick, 150); })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/*
  Same rows (Rachel, Oct 27): the % off stickers get a random shape (star /
  hex / clover / wavy) and colour on every page view instead of the fixed
  star-hex-clover-wavy / sky-blue-green-lime pattern from
  custom-product-figma.css. A sticker never shares its shape or colour with
  the card to its left, and no shape + colour pair repeats within a row.
  Sizes, offsets and the 60% scale per shape are the collection page's
  (custom-collection-figma.css), so the stickers sit the same way.
*/
(function () {
  var SHAPES = {
    star: ['50.6cqw', '48.7cqw', '-11cqw', '-20.75cqw'],
    hex: ['51.3cqw', '44.8cqw', '-14.7cqw', '-13.2cqw'],
    clover: ['35.7cqw', '35.7cqw', '-8cqw', '-9.3cqw'],
    wavy: ['37cqw', '38.3cqw', '-7.6cqw', '-9.3cqw']
  };
  var NAMES = Object.keys(SHAPES);
  var COLORS = ['#a9defe', '#c1b3ff', '#629b26', '#7598e9', '#bebe41'];
  var ROWS = '.template-product :is(.product-recommendations-section, .recently-viewed-section)';
  var urlTpl = null;

  function shapeUrl(name) {
    if (!urlTpl) {
      var any = document.querySelector(ROWS + ' .badge--sale');
      var m = any && getComputedStyle(any).webkitMaskImage;
      if (!m || m === 'none' || !/offe-sale-(star|hex|clover|wavy)/.test(m)) return null;
      urlTpl = m;
    }
    return urlTpl.replace(/offe-sale-(star|hex|clover|wavy)/, 'offe-sale-' + name);
  }
  function pick(prevShape, prevColor, used) {
    var ok = [];
    NAMES.forEach(function (s) {
      if (s === prevShape) return;
      COLORS.forEach(function (c) {
        if (c === prevColor || used[s + c]) return;
        ok.push([s, c]);
      });
    });
    if (!ok.length) NAMES.forEach(function (s) { COLORS.forEach(function (c) { ok.push([s, c]); }); });
    return ok[Math.floor(Math.random() * ok.length)];
  }
  function paintRow(row) {
    var items = row.querySelectorAll('.popular-products__item');
    var prevS = null, prevC = null, used = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.hasAttribute('data-offe-stk')) {
        prevS = item.getAttribute('data-offe-stk'); prevC = item.getAttribute('data-offe-fill');
        used[prevS + prevC] = 1;
        continue;
      }
      var badge = item.querySelector('.product-card__badges .badge--sale');
      var p = pick(prevS, prevC, used);
      prevS = p[0]; prevC = p[1]; used[p[0] + p[1]] = 1;
      item.setAttribute('data-offe-stk', p[0]);
      item.setAttribute('data-offe-fill', p[1]);
      if (!badge) continue;
      var url = shapeUrl(p[0]);
      if (!url) { item.removeAttribute('data-offe-stk'); continue; }
      var d = SHAPES[p[0]];
      badge.style.setProperty('--sale-shape', url);
      badge.style.setProperty('--sale-fill', p[1]);
      badge.style.setProperty('-webkit-mask-image', url, 'important');
      badge.style.setProperty('mask-image', url, 'important');
      badge.style.setProperty('background', p[1], 'important');
      badge.style.setProperty('width', d[0], 'important');
      badge.style.setProperty('height', d[1], 'important');
      badge.style.setProperty('left', d[2], 'important');
      badge.style.setProperty('top', d[3], 'important');
      // same size and corner as the collection page: scaled to 60% around
      // the point that sits on the card's corner
      badge.style.setProperty('transform', 'scale(.6)', 'important');
      badge.style.setProperty('transform-origin', d[2].replace('-', '') + ' ' + d[3].replace('-', ''), 'important');
    }
  }
  function run() {
    document.querySelectorAll(ROWS).forEach(paintRow);
  }
  function start() {
    if (!document.body.classList.contains('template-product')) return;
    run();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Phones and tablets (up to 1159px, Rachel Oct 27, Figma "Add to cart button
  on scroll - Mobile - Updated" 216:2047): once the page's ADD TO CART button
  has scrolled up out of view, a full-width periwinkle ADD TO CART bar sits
  at the bottom of the screen (the theme's sticky add bar, restyled in
  custom-product-sticker.css). It hides again when the main button comes
  back into view or the footer's bottom row is reached. It adds the size
  picked on the page. The accessibility button moves up while it shows.
*/
(function () {
  function start() {
    if (!document.body.classList.contains('template-product')) return;
    var bar = document.querySelector('.product-section .product-sticky-add-bar');
    if (!bar) return;
    var mq = window.matchMedia('(max-width: 1159.98px)');
    var raf = 0;
    function update() {
      raf = 0;
      var bb = document.querySelector('.product-section .product__buy-buttons > product-form');
      var fb = document.querySelector('.shopify-section-group-footer-group .footer-bottom');
      var on = mq.matches && !!bb && bb.getBoundingClientRect().bottom < 0 &&
        !(fb && fb.getBoundingClientRect().top < window.innerHeight);
      bar.classList.toggle('offe-sticky-on', on);
      document.body.classList.toggle('offe-sticky-atc', on);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();